<template>
  <div class="Warp">
    <van-form @submit="submit">
      <van-field
        name="商户背景"
        label="商户背景"
        :rules="[{ required: true, message: '请上传商户背景' }]"
      >
        <template #input>
          <van-uploader
            v-model="bg_file"
            :after-read="bgUploader"
            :max-count="1"
          />
        </template>
      </van-field>
      <van-field
        name="商户组图"
        label="商户组图"
        :rules="[{ required: true, message: '请上传商户组图' }]"
      >
        <template #input>
          <van-uploader
            v-model="fileList"
            multiple
            :max-count="5"
            :after-read="fileListUploader"
          />
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        name="选择商户"
        :value="selectMerchant.name"
        label="选择商户"
        placeholder="点击选择商户"
        @click="show_merchantList = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        readonly
        clickable
        name="商户行业"
        :value="selectIndustry"
        label="商户行业"
        placeholder="点击选择商户行业"
        @click="show_industry = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        readonly
        clickable
        name="营业时间"
        :value="business_hours"
        label="营业时间"
        placeholder="点击选择营业时间"
        @click="show_time = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        readonly
        clickable
        name="选择地址"
        :value="address"
        label="商户地址"
        placeholder="点击选择商户地址"
        @click="changeAddress"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        name="商户简介"
        label="商户简介"
        v-model="brief"
        rows="2"
        autosize
        type="textarea"
        maxlength="50"
        placeholder="请输入商户简介"
        show-word-limit
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        name="客服名称"
        v-model="service_name"
        label="客服名称"
        placeholder="请输入客服名称"
      />
      <van-field
        name="客服电话"
        v-model="service_tel"
        label="客服电话"
        placeholder="请输入客服电话"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <!-- 商户列表弹出框 -->
    <van-popup v-model="show_merchantList" round position="bottom">
      <van-picker
        show-toolbar
        :columns="merchantList"
        @cancel="show_merchantList = false"
        @confirm="changeMerchant"
      />
    </van-popup>
    <van-popup class="popup" v-model="show_merchantList" position="bottom">
      <form action="/" style="margin-bottom: 10px">
        <van-search
          v-model="keyword"
          placeholder="如商户不在列表内，请点此搜索查询"
          @search="onSearch"
        />
      </form>
      <van-picker
        show-toolbar
        :columns="merchantList"
        @cancel="show_merchantList = false"
        @confirm="changeMerchant"
        toolbar-position="bottom"
      />
      <div style="height: 30px"></div>
    </van-popup>
    <!-- 营业时间弹出框 -->
    <van-popup v-model="show_time" round position="bottom">
      <van-picker
        show-toolbar
        :columns="timeData"
        @cancel="show_time = false"
        @confirm="changeTime"
      />
    </van-popup>
    <!-- 商户行业弹出框 -->
    <van-popup v-model="show_industry" round position="bottom">
      <van-picker
        show-toolbar
        :columns="industryList"
        @cancel="show_industry = false"
        @confirm="changeIndustry"
      />
    </van-popup>
    <changeMap
      v-if="is_map"
      style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 999;"
      @getLocation="getLocation"
    ></changeMap>
  </div>
</template>
<script>
import { h, m } from "@/utils/time";
import changeMap from "@/components/map.vue";
export default {
  components: {
    changeMap,
  },
  data() {
    return {
      keyword: "",
      bg_file: [],
      fileList: [],
      show_merchantList: false,
      address: "",
      merchantList: [],
      show_time: false,
      show_industry: false,
      business_hours: "",
      is_map: false,
      selectMerchant: {
        name: "",
        id: 0,
      },
      mapShow: false,
      merchant_lat: "39.992950",
      merchant_lng: "116.310728",
      post_imgs: [],
      post_bg_img: "",
      brief: "",
      selectIndustry: "",
      industryList: [],
      timeData: [
        { values: h, defaultIndex: 0 },
        { values: [":"], defaultIndex: 0 },
        { values: m, defaultIndex: 0 },
        { values: ["--"], defaultIndex: 0 },
        { values: h, defaultIndex: 0 },
        { values: [":"], defaultIndex: 0 },
        { values: m, defaultIndex: 0 },
      ],
      service_name: "",
      service_tel: "",
    };
  },
  mounted() {
    this.getIndustry();
    this.getMerchantList();
  },
  activated() {
    this.getIndustry();
    this.getMerchantList();
  },

  methods: {
    //
    onSearch(v) {
      this.keyword = v;
      this.getMerchantList(2);
    },
    // onCancel(){
    //   this.keyword='';
    //   this.getMerchantList(2);
    // },
    // 清空数据
    refresh() {
      this.keyword = "";
      this.bg_file = [];
      this.fileList = [];
      this.address = "";
      (this.merchantList = [
        {
          text: "",
          value: 0,
        },
      ]),
        (this.show_time = false);
      this.business_hours = "";
      this.selectMerchant = 0;
      this.mapShow = false;
      this.merchant_lat = "";
      this.merchant_lng = "";
      this.post_imgs = [];
      this.post_bg_img = "";
      this.brief = "";
      (this.selectIndustry = ""),
        (this.timeData = [
          { values: h, defaultIndex: 0 },
          { values: [":"], defaultIndex: 0 },
          { values: m, defaultIndex: 0 },
          { values: ["--"], defaultIndex: 0 },
          { values: h, defaultIndex: 0 },
          { values: [":"], defaultIndex: 0 },
          { values: m, defaultIndex: 0 },
        ]);
      this.service_name = "";
      this.service_tel = "";
    },
    //获取位置
    getLocation(loc) {
      if (loc) {
        this.is_map = false;
        this.address = loc.poiaddress;
        this.merchant_lat = loc.latlng.lat;
        this.merchant_lng = loc.latlng.lng;
      } else {
        console.log("暂无位置信息");
      }
    },
    // 获取商户列表
    getMerchantList(type) {
      var reqData = {
        keyword: this.keyword,
        type: 1,
      };
      this.$http
        .get("/wechat/api.salesman/merchants", {
          params: reqData,
        })
        .then((res1) => {
          var res = res1.body;
          console.log(res);
          var values = [],
            defaultIndex = 0,
            merchant_id = [];
          if (res.data.length == 0) {
            this.$dialog
              .confirm({
                title: "暂无商户",
                // message: "弹窗内容",
                showCancelButton: false,
              })
              .then(() => {
                if (type == 2) {
                  (this.keyword = ""), this.getMerchantList();
                  return;
                }
                this.$router.go(-1);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          res.data.map((v) => {
            values.push(`${v.store_name}(${v.merchant_num})`);
            merchant_id.push(v.merchant_id);
          });
          var obj = {
            values,
            defaultIndex,
            merchant_id,
          };
          this.merchantList = [];
          this.merchantList.push(obj);
          console.log(this.merchantList);
        });
    },
    // 获取商户行业
    getIndustry() {
      this.$http.get("/wechat/api.Salesman/industryList").then((res1) => {
        var res = res1.body;
        console.log(res);
        this.industryList = res.data;
        // res.data.map((v) => {
        //   var obj = {
        //     id: v.id,
        //     text: v.name,
        //     // children: [{ id: 0, text: "暂不选择" }],
        //   };
        //   if (v.children.length > 0) {
        //     v.children.map((v1) => {
        //       var obj1 = {
        //         id: v1.id,
        //         text: v1.name,
        //       };
        //       obj.children.push(obj1);
        //     });
        //   }
        //   this.industryList.push(obj);
        // });
      });
    },
    // 上传背景组图
    fileListUploader(file) {
      this.Uploader(file, 2);
    },
    // 上传logo
    bgUploader(file) {
      this.Uploader(file, 1);
    },
    // 上传图片
    Uploader(file, type) {
      // var _this = this;
      // var imgUrl = this.$store.state.imgUrl;
      console.log(file);
      file.status = "uploading";
      file.message = "上传中...";
      // var reqFile = file.file;
      var formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post("/wechat/api.common/uploadImg", formData, { emulateJSON: true })
        .then((res1) => {
          // console.log(res);
          var res = res1.body;
          if (res.code == 200) {
            file.status = "done";
            if (type == 1) {
              this.post_bg_img = res.data;
            } else {
              this.post_imgs.push(res.data);
            }
          } else {
            file.status = "failed";
          }
          file.message = res.message;
        });
    },
    // 选择营业时间
    changeTime(v) {
      var string = "";
      v.map((item) => {
        string += item;
      });
      console.log(string);
      this.business_hours = string;
      this.show_time = false;
    },
    // 选择商户
    changeMerchant(v, i) {
      console.log(v, i);
      this.selectMerchant.name = v[0];
      console.log(this.merchantList);
      this.selectMerchant.id = this.merchantList[0].merchant_id[i[0]];
      console.log(this.selectMerchant);
      this.show_merchantList = false;
    },
    // 选择商户行业
    changeIndustry(v) {
      console.log(v);
      // var industry_first = this.industryList[i[0]];
      // var industry_second = this.industryList[i[0]].children[i[1]];
      // .id==0?'':this.industryList[i[0]].children[i[1]].text;
      // if (industry_second.id == 0) {
      //   this.selectIndustry = industry_first.text;
      // } else {
      //   this.selectIndustry = industry_first.text + "--" + industry_second.text;
      // }
      // console.log(industry_first,);
		this.selectIndustry=v.name
      this.industry_id_first = v.id;
      this.industry_id_second = 0;
      this.show_industry = false;
    },
    // 选择地址
    changeAddress() {
      this.is_map = true;
      // window.location.href = `https://apis.map.qq.com/tools/locpicker?search=1&type=0&key=V4RBZ-ACNC3-5PS3C-3PJCV-MNMGH-OVF76&referer=一点支付助手`
    },
    // 提交信息
    submit() {
      console.log(this.post_bg_img);
      console.log(this.post_imgs);
      var reqData = {
        apply_salesman_id: this.$cookie.get("salesmanInfo").id,
        merchant_id: this.selectMerchant.id,
        merchant_logo: this.post_bg_img,
        merchant_group_image: this.post_imgs.join(";"),
        merchant_lng: this.merchant_lng,
        merchant_lat: this.merchant_lat,
        merchant_detail: this.brief,
        business_hours: this.business_hours,
        service_name: this.service_name,
        service_tel: this.service_tel,
        industry_id_first: this.industry_id_first,
        industry_id_second: this.industry_id_second,
      };
      this.$http
        .post("/wechat/api.salesman/applyCoupon", reqData, {
          emulateJSON: true,
        })
        .then((res1) => {
          var res = res1.body;
          console.log(res);
          if (res.code == 200) {
            this.$toast.success(res.msg);
            this.refresh();
            this.$router.go(-1);
            // this.getMerchantList();
          } else {
            this.$toast.fail(res.msg);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.Warp {
  width: 100%;
  min-height: 100vh;
  background-color: #f6f7f9;

  .cell_group {
    width: 100%;
    background-color: #fff;
    .cell {
      width: 95%;
      // min-height: 50px;
      box-sizing: border-box;
      padding: 10px;
      margin: 0px auto;
      border-bottom: 1px dotted #ecedef;
      display: flex;
      //   overflow: hidden;
      .left {
        //   flex:1;
        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        .title {
          font-size: 14px;
          span {
          }
        }
      }
      .right {
        flex: 1;
        font-size: 14px;
        // display: flex;
        // align-items: center;
        /deep/.van-uploader__upload {
          margin: 0;
        }
        /deep/ .van-uploader__preview:nth-of-type(3n + 3) {
          margin-right: 0;
        }
        .van-cell {
          padding: 0;
        }
        input {
          border: none;
        }
      }
      .select {
        /deep/ .van-dropdown-menu__item {
          justify-content: flex-start;
        }
        /deep/ .van-dropdown-menu__title {
          padding: 0 0.21333rem 0 0;
          font-size: 14px;
        }
        /deep/ .van-dropdown-menu__bar {
          box-shadow: unset;
        }
      }
    }
  }
  .submit {
    width: 50%;
    // padding:15px;
    height: 50px;
    line-height: 50px;
    border-radius: 5px;

    margin: 20px auto;
    text-align: center;
    color: #fff;
    font-size: 16px;
    background-color: cornflowerblue;
  }
}
</style>